import {tokens} from '@pleo-io/telescope'
import styled from 'styled-components'

import {Section} from '@helios/shared/styles/grid'
import {text} from '@helios/shared/styles/typography'
import {fonts, colors} from '@helios/shared/theme'
import mq from '@helios/shared/utils/media-query'

export const TitleSection = styled(Section)`
    ${mq.min('sm')} {
        text-align: center;
    }

    ${mq.min('md')} {
        padding-top: 120px;
        padding-bottom: 120px;
    }

    strong {
        font-weight: ${fonts.weights.medium};
        background: ${colors.background.pink};
    }
`

export const TableTitleWrapper = styled.div`
    margin-bottom: ${tokens.spacing20};

    ${mq.min('sm')} {
        margin-bottom: ${tokens.spacing40};
    }
`

export const TableWrapper = styled.div`
    padding: ${tokens.spacing20} ${tokens.spacing16};
    background: ${colors.background.default};

    :not(:last-child) {
        margin-bottom: ${tokens.spacing12};

        ${mq.min('sm')} {
            margin-bottom: ${tokens.spacing40};
        }
    }

    ${mq.min('sm')} {
        padding: ${tokens.spacing40};
    }
`

export const Table = styled.table`
    width: 100%;
    border-collapse: collapse;

    th,
    td {
        padding: ${tokens.spacing16} 0;
        text-align: left;

        :not(:first-child) {
            width: 20%;
            text-align: center;
        }
    }

    thead {
        th {
            padding-top: 0;
            padding-bottom: ${tokens.spacing4};
            ${text({size: 'xs', font: 'secondary'})}

            ${mq.min('sm')} {
                padding-bottom: ${tokens.spacing20};
                ${text({size: 'sm', font: 'primary'})}
            }
        }
    }

    tbody {
        tr:not(:last-child) {
            border-bottom: 1px solid ${colors.border.default};
        }
    }

    td img {
        display: inline-block;
        width: 16px;

        ${mq.min('sm')} {
            width: 20px;
        }
    }
`
